import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { ModuleService } from './core/services/module.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('opscribe-frontend');
  private authService = inject(AuthService);
  private moduleService = inject(ModuleService);

  ngOnInit() {
    if (this.authService.isAuthenticated) {
      this.moduleService.refreshPermissions();
    }
  }
}
